export default function (): boolean {
  const metatags = Array.from(document.getElementsByTagName("meta"))
  for (let i = 0; i < metatags.length; i++) {
    const element = metatags[i]
    if (element.getAttribute("content") === "parmonic-widget-preview") {
      return true
    }
  }
  return false
}
